<script lang="ts">
  type $$Props = { config: ResponsiveImageConfig };
  export let config: ResponsiveImageConfig;
</script>

<div class="ResponsiveImagePartial">
  <picture>
    {#each config.tagConfigs as tagConfig}
      {#if tagConfig.nodeName === 'img'}
        <img class={config.resizeMode} {...tagConfig.nodeAttributes} />
      {:else}
        <source {...tagConfig.nodeAttributes} />
      {/if}
    {/each}
  </picture>
</div>

<style lang="scss">
  @layer standard-components {
    .fluid {
      width: 100%;
    }
  }
</style>
